import { Navigate, Outlet } from "react-router-dom";
import { isEmpty } from "../Utils/helpers";

const PrivateRoute = () => {
  return !isEmpty(localStorage.getItem("token")) ? (
    <Outlet />
  ) : (
    <Navigate to="/login" />
  );
};

export default PrivateRoute;
